import { useState, useEffect } from 'react';
import { getRoutes, getRouteBySlug } from '../services/api';

export const useRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        setLoading(true);
        const response = await getRoutes();
        setRoutes(response.data || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchRoutes();
  }, []);

  return { routes, loading, error };
};

export const useRoute = (slug) => {
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const fetchRoute = async () => {
      try {
        setLoading(true);
        const response = await getRouteBySlug(slug);
        const data = response.data?.[0] || null;
        setRoute(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchRoute();
  }, [slug]);

  return { route, loading, error };
};
